import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'

const module = 'incidenttypes'
let doc = {
  list: {
    name: "Types d'incidents",
    headers: [
      { label: 'Nom', value: 'name' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['incidenttypes.create'], dispatch: `${module}/openForm` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['incidenttypes.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
  },

  form: {
    name: "Type d'incident",
    fields: [
      { label: 'Titre', name: 'name', type: 'text', hint: "Comment vous souhaitez nommer ce type d'incidents" },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['incidenttypes.update'], dispatch: `${module}/update` },
      {
        icon: 'delete',
        isFlat: true,
        scope: ['incidenttypes.delete'],
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],
  },

  params: {
    fetchAll: {},
    fetchOne: {},
  },
}

export default crudmaker(module, apiClient, doc)
